// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.food_project_theme_enum */
var FoodProjectThemeEnum;
(function (FoodProjectThemeEnum) {
    FoodProjectThemeEnum["forest"] = "forest";
    FoodProjectThemeEnum["ocean"] = "ocean";
    FoodProjectThemeEnum["dusk"] = "dusk";
    FoodProjectThemeEnum["ember"] = "ember";
    FoodProjectThemeEnum["slate"] = "slate";
    FoodProjectThemeEnum["rose"] = "rose";
})(FoodProjectThemeEnum || (FoodProjectThemeEnum = {}));
;
export default FoodProjectThemeEnum;
/** Zod schema for food_project_theme_enum */
export const foodProjectThemeEnum = z.nativeEnum(FoodProjectThemeEnum);
//# sourceMappingURL=FoodProjectThemeEnum.js.map